'use es6';

import { createSelector } from 'reselect';
const getCmsUserSettingsState = state => state.cmsUserSettings;
const getCmsUserSettingsData = createSelector([getCmsUserSettingsState], state => state.data);
export const getCmsUserSettingsRequestStatus = createSelector([getCmsUserSettingsState], state => state.status);
export const getCustomDomainSetupNextReminderDate = createSelector([getCmsUserSettingsData], ({
  customDomainSetupNextReminderDate
}) => customDomainSetupNextReminderDate);